<p
  *ngIf="createdTimestamp"
  [ngStyle]="{
    'font-family': configs?.fonts?.bot_title_font,
    'text-align': textAlign
  }"
>
  {{ createdTimestamp }}
</p>
